import { SvgIcon, SvgIconProps } from "@mui/material";
import { AlphaGlyphFull } from "src/components/icons-mui/alpha-icon-glyph";

interface IIconAlphaLightProps extends SvgIconProps {
    hideBorder?: boolean;
}

export const IconAlphaLight = ({ hideBorder, ...props }: IIconAlphaLightProps) => (
    <SvgIcon {...props} viewBox={hideBorder ? "4.6 0 10 24" : "0 0 24 24"}>
        {!hideBorder && <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" stroke="#179C5F" strokeWidth="0.6" fill="none" />}
        <g clipPath="url(#clip0_alpha_light)" transform={hideBorder ? undefined : "translate(2.53 0)"}>
            <AlphaGlyphFull />
        </g>
        <defs>
            <clipPath id="clip0_alpha_light">
                <rect width="14.4" height="14.4" fill="white" transform="translate(4.60156 4.6001)" />
            </clipPath>
        </defs>
    </SvgIcon>
);
